import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zuoduiqi",
  "use": "icon-zuoduiqi-usage",
  "viewBox": "0 0 1047 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1047 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zuoduiqi\"><defs><style type=\"text/css\"></style></defs><path d=\"M1047.552 910.336H0V1024h1047.04v-113.664z m-349.184-113.664v-113.664H0v113.664h698.368z m349.184-341.504H0v113.664h1047.04V455.168z m-349.184-227.84H0v113.664h698.368V227.328zM0 0v113.664h1047.04V0H0z\" p-id=\"10898\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol